/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useCallback, useContext, useEffect } from "react";
import { Suspense, useState } from "react";
import { AuthContext, PaycheckContext } from "../../../../contexts";
import { ProfileDetailsProps } from "../../../../types/components/profileDetails.types";
import { Member } from "../../../../types/components/member.types";
import { CustomInput } from "../../../shared/CustomInput";
import initCapitalize from "../../../../utils/commonFunctions/initCapitalize";

import "./profileDetails.css";
import ProfileEditDialog from "./profileEditDialog/ProfileEditDialog";
import { mongoDBDateParserToUSAFormat } from "../../../../utils/commonFunctions/date";
import { maskedSSN } from "../../../../constants/maskSSN";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { formatSSN } from "../../../../utils/commonFunctions/SSN";
import { api } from "../../../../utils/api";
import { trackPromise } from "react-promise-tracker";

type Details = {
	"SSN / Alt Id": number;
	"Date of Birth": string;
	Gender: string;
	"Marital Status": string;
	"Employee Id": number;
};

const ProfileDetails = ({ member, isInputDisabled }: ProfileDetailsProps): JSX.Element => {
	const { SSN, date_of_birth, gender, member_id, marital_status } = member;
	const { paycheck } = useContext(PaycheckContext);
	const [details, setDetails] = useState({} as Details);
	const [editProfile, setEditProfile] = useState({
		date_of_birth: "",
		gender: "",
		marital_status: ""
	});
	const [showSSN, setShowSSN] = useState(false);
	// eslint-disable-next-line arrow-parens
	const toggleSSN = useCallback(async () => {
		try {
			if (!showSSN) {
				const viewSSNAddLogPayload = {
					member_id: (member as any).id,
					member_role: member?.role
				};
				// console.log(member);
				const response = await trackPromise(api.SSN.viewSSNAddLog(viewSSNAddLogPayload));

				// handle the response
				if (response) {
					setShowSSN((prev: any) => !prev);
				}
			} else {
				setShowSSN((prev: any) => !prev);
			}
		} catch (error) {
			console.error("Something Went Wrong,Please try again!", error);
		}
	}, [member, showSSN]);

	const getDetails = useCallback(() => {
		if (member === null) {
			return;
		}

		const dateObj = new Date(date_of_birth);
		const parsedDateOfBirth = dateObj.getMonth() + 1 + "-" + dateObj.getDate() + "-" + dateObj.getFullYear();
		// console.log("parsedDateOfBirth", mongoDBDateParserToUSAFormat(date_of_birth));
		member?.role === "EMPLOYEE"
			? setDetails((prevDetails: Details) => {
					return Object.assign({}, prevDetails, {
						"Employee Id": member_id,
						"SSN / Alt Id": SSN,
						"Date Of Birth": mongoDBDateParserToUSAFormat(date_of_birth),
						Gender: initCapitalize(gender),
						"Marital Status": initCapitalize(marital_status)
					});
			  })
			: setDetails((prevDetails: Details) => {
					return Object.assign({}, prevDetails, {
						"SSN / Alt Id": SSN,
						"Date Of Birth": mongoDBDateParserToUSAFormat(date_of_birth),
						Gender: initCapitalize(gender)
					});
			  });
	}, [SSN, date_of_birth, gender, marital_status, member, member_id]);

	useEffect((): void => {
		getDetails();
	}, [getDetails]);

	return (
		<>
			<div className="profile-details">
				<div className="details-form-container">
					{Object.entries(details).map(([label, value], index) => {
						const isSSN = label == "SSN";
						// console.log(label, value);
						return (
							<div className="details-form-row" key={index}>
								<div className="details-form-label">
									{label}
									{isSSN && (
										<IconButton onClick={toggleSSN} style={{ marginLeft: "8px" }} size="small">
											{!showSSN ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									)}
								</div>
								<Suspense fallback={<div />}>
									<CustomInput
										value={
											label == "SSN" && !showSSN
												? maskedSSN(value as string)
												: label == "SSN"
												? formatSSN(value as string)
												: value
										}
										disabled={isInputDisabled}
									/>
								</Suspense>
							</div>
						);
					})}
				</div>
			</div>
		</>
	);
};

export default ProfileDetails;
